<template>
  <span>
    <div style="width: 60%" class="mx-auto">
      <b-form @submit="applyForaBox">
        <div class="form-group mb-3 input-group input-text-wrapper">
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="user-plus" style="color: #ced4da" />
            </span>
          </div>
          <b-form-select
            v-model="customer_type"
            v-on:change="getSelectedCustomer"
            :options="customer_type_items"
            class="box-text-input"
            required
          >
          </b-form-select>
        </div>

        <!--   Company Forms-->
        <br />

        <div
          v-if="companyForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="university" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formCompany.company_name"
            type="text"
            required
            placeholder="Company Name"
          ></b-form-input>
        </div>

        <div
          v-if="companyForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon
                icon="sort-numeric-down"
                style="color: #ced4da"
              />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formCompany.brn_or_rn"
            type="text"
            required
            placeholder="Business Registration Number or Reservation Number"
          ></b-form-input>
        </div>

        <b-form-group
          v-if="companyForm"
          description="Date and Year of Registration/Date of Reservation"
        >
          <div class="form-group mb-3 input-group input-text-wrapper">
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                style="background-color: #ffffff; border: none"
              >
                <font-awesome-icon icon="calendar" style="color: #ced4da" />
              </span>
            </div>
            <b-form-input
              class="box-text-input"
              v-model="formCompany.registration_date"
              type="date"
              required
              placeholder="Date and Year of Registration/Date of Reservation"
            ></b-form-input>
          </div>
        </b-form-group>

        <div
          v-if="companyForm"
          class="mt-6 form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="phone" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formCompany.company_phone"
            type="text"
            required
            placeholder="Phone Number"
          ></b-form-input>
        </div>

        <div
          v-if="companyForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="envelope" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formCompany.company_email"
            type="text"
            required
            placeholder="Email"
          ></b-form-input>
        </div>

        <br />

        <h6 v-if="companyForm" class="text-center">
          Contact Person (Director, Shareholders)
        </h6>

        <div
          v-if="companyForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="user" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formCompany.company_contact_name"
            type="text"
            required
            placeholder="Names"
          ></b-form-input>
        </div>

        <div
          v-if="companyForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="phone" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formCompany.company_contact_phone"
            type="text"
            required
            placeholder="Phone"
          ></b-form-input>
        </div>

        <div
          v-if="companyForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="envelope" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formCompany.company_contact_email"
            type="text"
            required
            placeholder="Email"
          ></b-form-input>
        </div>

        <!--   Individual -->

        <div
          v-if="individualForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="user" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formIndividual.individual_first_name"
            type="text"
            required
            placeholder="First Name"
          ></b-form-input>
        </div>

        <div
          v-if="individualForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="user" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formIndividual.individual_last_name"
            type="text"
            required
            placeholder="Last Name"
          ></b-form-input>
        </div>

        <div
          v-if="individualForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="phone" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formIndividual.individual_phone"
            type="text"
            required
            placeholder="Phone"
          ></b-form-input>
        </div>

        <div
          v-if="individualForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="user" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formIndividual.individual_nationality"
            type="text"
            required
            placeholder="Nationality "
          ></b-form-input>
        </div>

        <div
          v-if="individualForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="envelope" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formIndividual.individual_email"
            type="text"
            required
            placeholder="Email"
          ></b-form-input>
        </div>

        <div
          v-if="individualForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="id-badge" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formIndividual.individual_id_number"
            type="text"
            required
            placeholder="NIN/Passport No/Driving Permit/NSSF No"
          ></b-form-input>
        </div>

        <!--   c.	MDA (Ministry, Department, Agency) -->

        <div
          v-if="mdaForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="user" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formMda.mda_name"
            type="text"
            required
            placeholder="MDA Name"
          ></b-form-input>
        </div>

        <b-form-group
          v-if="mdaForm"
          class="mt-6"
          description="Attach Letter of authorization from the accounting officer"
        >
          <b-form-file
            v-model="formMda.mda_authorization"
            size="sm"
          ></b-form-file>
        </b-form-group>

        <div
          v-if="mdaForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="phone" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formMda.mda_telephone"
            type="text"
            required
            placeholder="Telephone Number"
          ></b-form-input>
        </div>

        <div
          v-if="mdaForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="envelope" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formMda.mda_email"
            type="text"
            required
            placeholder="Email"
          ></b-form-input>
        </div>

        <h6 v-if="mdaForm" class="text-center mt-7">
          Accounting officer Details
        </h6>

        <div
          v-if="mdaForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="user" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formMda.mda_officer_name"
            type="text"
            required
            placeholder="Name"
          ></b-form-input>
        </div>

        <div
          v-if="mdaForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="envelope" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formMda.mda_officer_email"
            type="text"
            required
            placeholder="Email"
          ></b-form-input>
        </div>

        <div
          v-if="mdaForm"
          class="form-group mb-3 input-group input-text-wrapper"
        >
          <div class="input-group-prepend">
            <span
              class="input-group-text"
              style="background-color: #ffffff; border: none"
            >
              <font-awesome-icon icon="phone" style="color: #ced4da" />
            </span>
          </div>
          <b-form-input
            class="box-text-input"
            v-model="formMda.mda_officer_phone"
            type="text"
            required
            placeholder="Telephone"
          ></b-form-input>
        </div>

        <br />
        <button
          class="form-control signUpButtonCard button"
          style="margin-bottom: 4%"
          type="submit"
        >
          Next
          <b-spinner
            v-if="customerDetailsSpinner"
            label="Loading..."
            small
          ></b-spinner>
        </button>
      </b-form>
    </div>
  </span>
</template>

<script>
export default {
  name: "CustomerDetails",
  data() {
    return {
      dataCheck: null,
      customerDetailsSpinner: false,
      companyForm: false,
      individualForm: false,
      mdaForm: false,
      customer_type: null,
      formCompany: {
        company_name: null,
        brn_or_rn: null,
        registration_date: null,
        company_phone: null,
        company_email: null,
        company_contact_name: null,
        company_contact_phone: null,
        company_contact_email: null,
      },
      formIndividual: {
        individual_first_name: null,
        individual_last_name: null,
        individual_phone: null,
        individual_nationality: null,
        individual_email: null,
        individual_id_number: null,
      },
      formMda: {
        mda_name: null,
        mda_authorization: null,
        mda_telephone: null,
        mda_email: null,
        mda_officer_name: null,
        mda_officer_email: null,
        mda_officer_phone: null,
      },
      customer_type_items: [
        { value: null, text: "Select Customer Type" },
        { value: "company", text: "Company" },
        { value: "individual", text: "Individual" },
        { value: "mda", text: "MDA (Ministry, Department, Agency)" },
      ],
      id_type_item: [
        { value: null, text: "Select Id Type" },
        { value: "national_id", text: "National ID" },
        { value: "driving_permit", text: "Driving Permit" },
        { value: "passport", text: "Passport" },
        { value: "other", text: "Other" },
      ],
    };
  },
  methods: {
    applyForaBox(env) {
      env.preventDefault();

      let customerForm = {};

      if (this.customer_type === "company") {
        customerForm = this.formCompany;
      } else if (this.customer_type === "individual") {
        customerForm = this.formIndividual;
      } else if (this.customer_type === "mda") {
        customerForm = this.formMda;
      }

      customerForm.customer_type = this.customer_type;

      // alert(JSON.stringify(customerForm));
      //this.dataCheck = JSON.stringify(customerForm)

      this.$emit("customerDetails", customerForm);
      this.$emit("goTo", 2);
    },
    getSelectedCustomer(data) {
      if (data === "company") {
        this.companyForm = true;
        this.individualForm = false;
        this.mdaForm = false;
      } else if (data === "individual") {
        this.companyForm = false;
        this.individualForm = true;
        this.mdaForm = false;
      } else if (data === "mda") {
        this.companyForm = false;
        this.individualForm = false;
        this.mdaForm = true;
      } else {
        this.companyForm = false;
        this.individualForm = false;
        this.mdaForm = false;
      }
    },
  },
  computed: {},
};
</script>

<style scoped>
.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 3%;
}

.button {
  width: 100%;
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
}

.button:hover {
  background: #9f0012;
}
</style>
